const WEB_FALLBACK_PARAM = 'web';
const APP_PACKAGE = 'com.mocker.mockloc';

export function isAndroid(): boolean {
  return /Android/i.test(navigator.userAgent);
}

export function isWebsiteFallback(search: string): boolean {
  return new URLSearchParams(search).get(WEB_FALLBACK_PARAM) === '1';
}

export function buildMockLocAppUri(pathname: string, search: string): string | null {
  const params = new URLSearchParams(search);

  if (pathname.startsWith('/dl-stpoint')) {
    const lat = params.get('lat');
    const lng = params.get('lng');
    if (!lat || !lng) {
      return null;
    }
    const address = params.get('address') ?? '';
    return `mockloc://stpoint?lat=${encodeURIComponent(lat)}&lng=${encodeURIComponent(lng)}&address=${encodeURIComponent(address)}`;
  }

  if (pathname.startsWith('/dl-playlist-points')) {
    const id = params.get('id');
    if (!id) {
      return null;
    }
    return `mockloc://playlist?id=${encodeURIComponent(id)}`;
  }

  if (pathname.startsWith('/dl-itinerary')) {
    const id = params.get('id');
    if (!id) {
      return null;
    }
    return `mockloc://itinerary?id=${encodeURIComponent(id)}`;
  }

  if (pathname.startsWith('/dl-reset-password')) {
    const token = params.get('token');
    if (!token) {
      return null;
    }
    return `mockloc://reset-password?token=${encodeURIComponent(token)}`;
  }

  return null;
}

export function buildIntentUrl(appUri: string, fallbackUrl: string): string {
  const intentPath = appUri.replace(/^mockloc:\/\//, '');
  return `intent://${intentPath}#Intent;scheme=mockloc;package=${APP_PACKAGE};S.browser_fallback_url=${encodeURIComponent(fallbackUrl)};end`;
}

export function websiteFallbackUrl(): string {
  const url = new URL(window.location.href);
  url.searchParams.set(WEB_FALLBACK_PARAM, '1');
  return url.toString();
}

/** Opens Mock Loc when installed; otherwise stays on this website (not Play Store). */
export function tryOpenMockLocApp(pathname: string, search: string): void {
  if (!isAndroid() || isWebsiteFallback(search)) {
    return;
  }

  const appUri = buildMockLocAppUri(pathname, search);
  if (!appUri) {
    return;
  }

  window.location.replace(buildIntentUrl(appUri, websiteFallbackUrl()));
}
